export const getWarningText = (props, requiredConfig) => {
    if (!props || !requiredConfig) {
        return;
    }
    const requiredKeys = Object.keys(requiredConfig);
    const messages = [];
    for (let index = 0; index < requiredKeys.length; index++) {
        const key = requiredKeys[index];
        const checkKey = key;
        const config = requiredConfig[key];
        const isRequired = config.isRequired(props);
        if (!(checkKey in props) && isRequired) {
            messages.push({
                message: `"${key}" is missing: ${config.message}`,
                verbose: config.verbose,
            });
        }
    }
    return messages;
};
const requiredPropWarningFactory = (prefix, verbose) => (props, requiredConfig) => {
    // Early exit for production env
    if (typeof process !== "undefined" &&
        process.env?.NODE_ENV === "production") {
        return;
    }
    const messages = getWarningText(props, requiredConfig);
    if (messages) {
        messages.forEach(({ message, verbose: messageVerbose }) => {
            const verboseWithFallback = messageVerbose || verbose;
            if (verboseWithFallback === "throw") {
                throw new Error(`${prefix}: ${message}`);
            }
            else {
                const method = (messageVerbose || verbose).split(".")[1];
                // eslint-disable-next-line no-console
                console[method](`${prefix}: ${message}`);
            }
        });
    }
};
export default requiredPropWarningFactory;
